import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  DiffParams,
  diffParamsToStrings,
  queryStringTodiffParams,
} from "./diff_params";
import { ForecastAccuracyContainer } from "./container";
import { Page } from "../../frameworks/joy/layouts/page";

export const ForecastAccuracyPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [diffParams, setDiffParams] = useState<DiffParams>({
    actualsEngineRunId: null,
    forecastEngineRunId: null,
    minDate: null,
    maxDate: null,
    salesMeasure: null,
    segmentation: null,
  });

  useEffect(() => {
    setDiffParams(queryStringTodiffParams(searchParams));
  }, [searchParams, setDiffParams]);

  const updateDiffParams = (params: DiffParams) => {
    setSearchParams(diffParamsToStrings(params), { replace: true });
  };

  return (
    <Page>
      <ForecastAccuracyContainer
        diffParams={diffParams}
        updateDiffParams={updateDiffParams}
      />
    </Page>
  );
};
